export default __webpack_public_path__ + "static/media/regulatory--toll-pass-only--g1.971da401.png";